import { afterNextRender, Directive, effect, ElementRef, inject, Injector, OnInit, untracked } from '@angular/core'
import { FormField } from '@angular/forms/signals'

/**
 * Appends the required asterisk to placeholder content for <textarea> and <input> fields that are required.
 * Note that the asterisk is applied automatically for mat-form-fields that contain mat-labels (mat-label acts both as a placeholder and label).
 * However, there are cases where the placeholder is provided instead and there is no need for the label. For such cases, this directive triggers and
 * provides similar user experience.
 *
 * Note that this directive's logic has been implemented for mat-select via CSS. Search for keyword 'PlaceholderWithRequiredIndicatorDirective' from global CSS.
 * This is due to mat-select having a separate element that can be injected conditionally with content via the pseudo selectors.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'textarea[placeholder][required], input[placeholder][required], textarea[placeholder][formField][tahtiOhjeeseen], input[placeholder][formField][tahtiOhjeeseen]',
  standalone: false,
})
export class PlaceholderWithRequiredIndicatorDirective implements OnInit {
  private readonly _kentta = inject(FormField, { optional: true, self: true })

  constructor(private _element: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {
    if (this._kentta) {
      // Signal Forms -kentältä puuttuu templaten required-attribuutti, joten tähti valitaan tahtiOhjeeseen-attribuutilla ja seuraa skeeman pakollisuutta
      const injector = inject(Injector)
      let alkuperainen: string | null = null
      effect(() => {
        const pakollinen = this._kentta.state().required()
        untracked(() =>
          afterNextRender(
            () => {
              const elementti = this._element.nativeElement
              alkuperainen ??= elementti.placeholder
              if (alkuperainen) {
                elementti.placeholder = pakollinen ? alkuperainen + ' *' : alkuperainen
              }
            },
            { injector },
          ),
        )
      })
    }
  }

  ngOnInit() {
    if (!this._kentta && this._element?.nativeElement?.placeholder) {
      this._element.nativeElement.placeholder += ' *'
    }
  }
}
